import { t } from "ttag";

import { usePatientQuery } from "@/app/hooks";
import { Header } from "@/shared/ui";

export const HomeHeader = () => {
  const { data: patient } = usePatientQuery();

  const patientName = patient?.firstName ? `, ${patient.firstName}` : "";

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Title>{t`Keep it up${patientName}!`} 💪</Header.Title>
      </Header.Content>
    </Header.Root>
  );
};
